import { Submission } from "@/models/database/submissions/Submission.model";
import { create } from "zustand";

interface SubmissionsState {
  submissions: Submission[] | null;
  loading: boolean;
  error: Error | null;
  setSubmissions: (submissions: Submission[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: Error | null) => void;
  addSubmission: (submissionItem: Submission) => void;
  updateSubmission: (submissionItem: Submission) => void;
}

export const useSubmissionsStore = create<SubmissionsState>((set, get) => ({
  submissions: null,
  loading: true,
  error: null,
  setSubmissions: (submissions) => set({ submissions }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  addSubmission: (submissionItem) => {
    const { submissions } = get();
    set({
      submissions: submissions
        ? [...submissions, submissionItem]
        : [submissionItem],
    });
  },
  updateSubmission: (submissionItem) => {
    const { submissions } = get();

    if (submissions) {
      // Find the specific submission to update
      const submissionToUpdate = submissions.find(
        (submission) => submission.id === submissionItem.id
      );

      if (submissionToUpdate) {
        // Update the specific submission
        const updatedSubmissions = submissions.map((submission) =>
          submission.id === submissionItem.id
            ? { ...submission, ...submissionItem }
            : submission
        );
        set({ submissions: updatedSubmissions });
      }
    }
  },
}));
